module.exports = __webpack_public_path__ + "static/media/m_faceshape_diamond_vector.ff7e2582.svg";